'use-client';
import React, { forwardRef } from 'react';
import classNames from 'clsx';
import {
  formatClassNames,
  getDataAttributes,
} from '@wix/editor-elements-common-utils';
import type {
  GoogleMapReactProps,
  IGoogleMapsImperativeActions,
} from '../GoogleMap.types';

import semanticClassNames from '../GoogleMap.semanticClassNames';
import style from './style/GoogleMapReact.module.scss';

const GoogleMapReact = forwardRef<
  IGoogleMapsImperativeActions,
  GoogleMapReactProps
>((props, forwardedRef) => {
  const {
    id,
    className,
    skin,
    customClassNames = [],
    translations,
    lang,
    onMouseEnter,
    onMouseLeave,
    MapContent,
  } = props;

  const domSafeProps = {
    id,
    className: classNames(
      style[skin],
      className,
      formatClassNames(semanticClassNames.root, ...customClassNames),
    ),
    ...getDataAttributes(props),
    lang,
  };

  return (
    <div
      {...domSafeProps}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div
        className={style.mapContainer}
        aria-label={translations.title}
        role="region"
      >
        <MapContent {...props} ref={forwardedRef} />
      </div>
    </div>
  );
});

export default GoogleMapReact;
